import { Component, Input } from '@angular/core';

export enum StageStepStatus {
  Completed = 'completed',
  Active = 'active',
  PastDue = 'pastdue',
  Pending = 'pending'
}

export interface StageStep {
  label: string;
  status: StageStepStatus;
}

const STATUS_LABELS: Record<StageStepStatus, string> = {
  [StageStepStatus.Completed]: 'Complete',
  [StageStepStatus.Active]: 'Active',
  [StageStepStatus.PastDue]: 'Past Due',
  [StageStepStatus.Pending]: 'Not Started'
};

@Component({
  selector: 'stage-stepper',
  templateUrl: './stage-stepper.component.html',
  styleUrls: ['./stage-stepper.component.scss']
})
export class StageStepperComponent {
  @Input() steps: StageStep[] = [];

  // Template can't reference the enum directly — expose it.
  readonly Status = StageStepStatus;

  // Callers rebuild the step array on every change-detection pass; without this
  // the whole stepper is torn down and re-rendered each tick.
  trackByIndex(index: number): number { return index; }

  statusLabel(step: StageStep): string {
    return STATUS_LABELS[step.status];
  }
}
